import React from 'react'
import Container from 'react-bootstrap/Container';
import Figure from 'react-bootstrap/Figure'
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Outlet } from 'react-router-dom';
import '../mysass.scss';



const Header = () => {

  return (
<>


<Navbar className='navbarfixed' collapseOnSelect expand="lg" bg="warning" style={{position:'sticky',zIndex:'1000',width:'100%',top:'0'}}>
      <Container>
      <Figure>
      <Figure.Image className='kosovologo' style={{marginTop:'25px'}}
        href='/'
        width={70}
        height={70}
        src="kosovologo.png"
      />
      </Figure>
        <Navbar.Brand className='header1' style={{fontFamily: 'Frijole, cursive',}} href="/">trip to kosovo</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="navbarspacing m-auto"         
          style={{
          fontFamily: 'Black Ops One, cursive', 
          fontSize:'15px',
          color:'white',
          textIndent:'40px'
        }}>
        
            <Nav.Link className='headerhome' href="#home">Home</Nav.Link>
            <Nav.Link className='headerabout' href="#about" >About</Nav.Link>
            <Nav.Link className='headercontact' href="#cities" >Cities</Nav.Link>
            <Nav.Link className='headercontact' href="#nature" >Nature</Nav.Link>
            <Nav.Link className='headercontact' href="#culture" >Culture</Nav.Link>
            <Nav.Link className='headercontact' href="#lifestyle" >Lifestyle</Nav.Link>
            <Nav.Link className='headercontact' href="#contact" >Contact</Nav.Link>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    




      

      <Outlet/>
</>
  )
}

export default Header